export const CUSTOMER_STATUSES = {
  10: 'Active',
  20: 'Blocked',
};
